var _defs, _path, _path2, _path3, _circle, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _path6, _path7, _path8, _circle6, _path9, _path0, _path1, _circle7, _circle8, _circle9, _path10, _path11, _path12, _circle0, _path13, _path14, _path15, _path16, _circle1, _circle10, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle11, _circle12, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet_1_",
    "data-name": "wallet (1)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.059,
    height: 50,
    viewBox: "0 0 47.059 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.391,
    y1: 0.377,
    x2: 0.644,
    y2: 1.082,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.475,
    y1: 0.605,
    x2: -0.037,
    y2: -0.615,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.374,
    y1: 0.367,
    x2: 0.565,
    y2: 1.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b302"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.705,
    y1: 0.774,
    x2: -0.8,
    y2: -0.204,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.556,
    y1: 0.376,
    x2: -0.625,
    y2: 0.087,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.148,
    y1: 0.464,
    x2: 0.769,
    y2: 0.877,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.738,
    y1: 3.027,
    x2: -1.796,
    y2: 4.044,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.823,
    y1: -2.945,
    x2: 0.119,
    y2: -1.927,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -0.217,
    y1: 3.836,
    x2: 0.725,
    y2: 4.853,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.698,
    y1: -2.136,
    x2: 2.64,
    y2: -1.119,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.252,
    y1: 0.407,
    x2: 0.533,
    y2: 1.044,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.338,
    y1: 0.613,
    x2: -0.234,
    y2: -0.485,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.179,
    y1: 0.407,
    x2: 0.397,
    y2: 0.985,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.372,
    y1: 0.825,
    x2: -1.132,
    y2: -0.153,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.361,
    y1: 0.369,
    x2: -0.934,
    y2: 0.094,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.3,
    y1: 0.549,
    x2: 0.277,
    y2: 1.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -6.116,
    y1: 3.982,
    x2: -5.174,
    y2: 4.999,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -1.689,
    y1: -4.461,
    x2: -0.747,
    y2: -3.444,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -2.552,
    y1: 5.852,
    x2: -1.61,
    y2: 6.869,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.877,
    y1: -2.592,
    x2: 2.819,
    y2: -1.574,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.018,
    y1: 0.372,
    x2: 0.344,
    y2: 1.019,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.078,
    y1: 0.58,
    x2: -0.663,
    y2: -0.532,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.167,
    y1: 0.372,
    x2: 0.105,
    y2: 0.909,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.029,
    y1: 0.729,
    x2: -1.534,
    y2: -0.249,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.07,
    y1: 0.301,
    x2: -0.964,
    y2: 0.009,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -0.741,
    y1: 0.363,
    x2: -0.213,
    y2: 0.911,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -9.959,
    y1: 3.581,
    x2: -9.017,
    y2: 4.598,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2.333,
    y1: -6.337,
    x2: -1.391,
    y2: -5.32,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -5.773,
    y1: 6.803,
    x2: -4.831,
    y2: 7.82,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1.855,
    y1: -3.117,
    x2: 2.797,
    y2: -2.1,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.23,
    y1: -0.092,
    x2: 0.797,
    y2: 1.15,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.563,
    y1: 0.578,
    x2: -0.087,
    y2: -0.217,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c59b6d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#c69d71",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#cba57c",
    stopOpacity: 0.345
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#d2b28e",
    stopOpacity: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#ddc4a8",
    stopOpacity: 0.659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811,
    stopColor: "#eadbca",
    stopOpacity: 0.812
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.959,
    stopColor: "#faf6f2",
    stopOpacity: 0.961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.385,
    y1: 0.345,
    x2: 1.105,
    y2: 1.316,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.963,
    y1: 0.766,
    x2: 0.416,
    y2: -0.139,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.192,
    y1: -0.058,
    x2: 0.842,
    y2: 1.118,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.551,
    y1: 0.574,
    x2: -0.024,
    y2: -0.258,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.862,
    y1: 1.19,
    x2: 0.295,
    y2: 0.407,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.356,
    cy: 0.308,
    r: 0.623,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#ffd744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#ffcf3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#ffc237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#ffaf2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.597,
    y1: 0.597,
    x2: -0.073,
    y2: -0.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.696,
    y1: 0.492,
    x2: 1.68,
    y2: -0.34,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.5,
    y1: 0.63,
    x2: 0.5,
    y2: -0.385,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.853,
    y1: 1.003,
    x2: 0.326,
    y2: 0.527,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.5,
    y1: 0.021,
    x2: 0.5,
    y2: 1.317,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.5,
    y1: 0.039,
    x2: 0.5,
    y2: 2.22,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.484,
    y1: 0.304,
    x2: 0.37,
    y2: -1.119,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 0.021,
    y2: 1.317,
    xlinkHref: "#linear-gradient-42"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0.484,
    y1: 0.304,
    x2: 0.37,
    y2: -1.119,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 0.484,
    y1: 0.304,
    x2: 0.37,
    y2: -1.119,
    xlinkHref: "#linear-gradient-38"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    "data-name": "Path 3268",
    d: "M86.642,70.677,60.99,52.329a.927.927,0,0,1-.215-1.293l9.577-13.389a.927.927,0,0,1,1.293-.215L97.3,55.78a.927.927,0,0,1,.215,1.293L87.934,70.462A.926.926,0,0,1,86.642,70.677Z",
    transform: "translate(-56.132 -33.607)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    "data-name": "Path 3269",
    d: "M95.185,78.273,70.649,60.723a.874.874,0,0,1-.2-1.219l8.9-12.442a.874.874,0,0,1,1.219-.2L105.1,64.41a.874.874,0,0,1,.2,1.219L96.4,78.071A.874.874,0,0,1,95.185,78.273Z",
    transform: "translate(-64.864 -42.118)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3270",
    "data-name": "Path 3270",
    d: "M137.974,103.095a2.8,2.8,0,0,1-.649-3.907q.055-.078.115-.15a.518.518,0,0,0-.1-.751L120.126,85.972a.518.518,0,0,0-.743.15q-.049.08-.1.157a2.8,2.8,0,0,1-3.907.649l0,0a.522.522,0,0,0-.732.114L111.1,91.98a.522.522,0,0,0,.129.73l0,0a2.8,2.8,0,0,1,.649,3.907q-.055.077-.115.15a.518.518,0,0,0,.1.751l17.217,12.315a.518.518,0,0,0,.743-.15q.049-.08.1-.157a2.8,2.8,0,0,1,3.907-.649l0,0a.522.522,0,0,0,.732-.114l3.535-4.941a.522.522,0,0,0-.129-.73Z",
    transform: "translate(-101.592 -77.456)",
    fill: "url(#linear-gradient-3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 6.38,
    cy: 6.38,
    r: 6.38,
    transform: "translate(16.632 14.068)",
    fill: "url(#linear-gradient-4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    "data-name": "Path 3271",
    d: "M215.95,168.37a1.077,1.077,0,0,0-.239-.636,4.363,4.363,0,0,0-.654-.741.477.477,0,0,0-.028-.057l-.1-.732a.424.424,0,0,0-.157-.22.391.391,0,0,0-.259-.078.255.255,0,0,0-.2.1l-.211.294a3.133,3.133,0,0,0-1.767-.436,2.011,2.011,0,0,0-1.511.943,2.649,2.649,0,0,0-.338.623,1.435,1.435,0,0,0-.089.618,4.583,4.583,0,0,0,.074.551v0l.364,2.19c0,.021.006.041.009.062l-1.214,1.7a2.174,2.174,0,0,1-.626-.8,4.135,4.135,0,0,1-.267-.765.677.677,0,0,0-.189-.4.493.493,0,0,0-.461-.038.8.8,0,0,0-.416.284,1.017,1.017,0,0,0-.087.855l1.261,7.6,10.115,7.235Z",
    transform: "translate(-188.66 -149.597)",
    fill: "url(#linear-gradient-5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    d: "M207.674,170.832a.8.8,0,0,1,.416-.284.493.493,0,0,1,.461.038.676.676,0,0,1,.19.4,4.127,4.127,0,0,0,.267.765,2.172,2.172,0,0,0,.626.8l1.7-2.38q-.225-.329-.34-.511t-.294-.5a2.006,2.006,0,0,1-.228-.561,4.609,4.609,0,0,1-.074-.551,1.435,1.435,0,0,1,.089-.618,2.649,2.649,0,0,1,.338-.623,2.011,2.011,0,0,1,1.511-.943,3.133,3.133,0,0,1,1.767.436l.211-.294a.255.255,0,0,1,.2-.1.39.39,0,0,1,.259.078.424.424,0,0,1,.157.22.248.248,0,0,1-.02.231l-.2.274a4.581,4.581,0,0,1,.993,1.025q.388.562.149.9a.891.891,0,0,1-.4.293.457.457,0,0,1-.469-.036,2.113,2.113,0,0,1-.321-.491,2.655,2.655,0,0,0-.625-.754l-1.471,2.057a8.147,8.147,0,0,1,.465.769,4,4,0,0,1,.294.784,1.868,1.868,0,0,1,.011.934,2.8,2.8,0,0,1-.468.974,2.508,2.508,0,0,1-1.526,1.088,2.688,2.688,0,0,1-1.812-.3l-.243.339a.243.243,0,0,1-.211.091.429.429,0,0,1-.258-.079.4.4,0,0,1-.158-.218.249.249,0,0,1,.028-.221l.221-.309a3.413,3.413,0,0,1-1.208-1.475A1.3,1.3,0,0,1,207.674,170.832Zm4.23-3.4a.914.914,0,0,0-.185.779,3.088,3.088,0,0,0,.459.918l1.32-1.845Q212.427,166.7,211.9,167.427Zm-1.719,5.492a1.163,1.163,0,0,0,1.611-.364,1.219,1.219,0,0,0,.266-.866,2.339,2.339,0,0,0-.348-.908Z",
    transform: "translate(-188.66 -149.599)",
    fill: "url(#linear-gradient-6)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(13.968 6.543)",
    fill: "url(#linear-gradient-7)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(36.086 22.364)",
    fill: "url(#linear-gradient-8)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(7.288 15.883)",
    fill: "url(#linear-gradient-9)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(29.406 31.703)",
    fill: "url(#linear-gradient-10)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3273",
    "data-name": "Path 3273",
    d: "M145.9,36.757,127.965,10.814a.926.926,0,0,1,.235-1.289L141.742.165A.926.926,0,0,1,143.031.4l17.932,25.944a.927.927,0,0,1-.235,1.289l-13.542,9.36A.927.927,0,0,1,145.9,36.757Z",
    transform: "translate(-116.742 -0.001)",
    fill: "url(#linear-gradient-11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    "data-name": "Path 3274",
    d: "M154.508,44.551,137.355,19.736a.874.874,0,0,1,.222-1.216l12.584-8.7a.874.874,0,0,1,1.216.222L168.529,34.86a.874.874,0,0,1-.222,1.216l-12.584,8.7A.874.874,0,0,1,154.508,44.551Z",
    transform: "translate(-125.22 -8.719)",
    fill: "url(#linear-gradient-12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    "data-name": "Path 3275",
    d: "M198.651,72.973a2.8,2.8,0,0,1,.711-3.9q.078-.054.159-.1a.518.518,0,0,0,.162-.74L187.647,50.822a.518.518,0,0,0-.75-.11q-.073.059-.152.113a2.8,2.8,0,0,1-3.9-.711l0,0a.522.522,0,0,0-.727-.14l-5,3.454a.522.522,0,0,0-.126.73l0,0a2.8,2.8,0,0,1-.711,3.9q-.078.054-.159.1a.518.518,0,0,0-.162.74L188,76.308a.518.518,0,0,0,.75.11q.073-.059.152-.113a2.8,2.8,0,0,1,3.9.711l0,0a.522.522,0,0,0,.727.14l5-3.454a.522.522,0,0,0,.126-.73l0,0Z",
    transform: "translate(-160.103 -44.987)",
    fill: "url(#linear-gradient-13)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 6.38,
    cy: 6.38,
    r: 6.38,
    transform: "translate(21.342 12.199)",
    fill: "url(#linear-gradient-14)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M249.157,154.63a1.076,1.076,0,0,0-.009-.68,4.361,4.361,0,0,0-.365-.918.468.468,0,0,0-.007-.063l.158-.722a.423.423,0,0,0-.074-.26.39.39,0,0,0-.217-.161.255.255,0,0,0-.225.026l-.3.206a3.132,3.132,0,0,0-1.516-1.008,2.011,2.011,0,0,0-1.74.376,2.648,2.648,0,0,0-.529.472,1.435,1.435,0,0,0-.293.551,4.593,4.593,0,0,0-.117.543v0l-.4,2.184c0,.021-.008.041-.013.061l-1.717,1.187a2.172,2.172,0,0,1-.318-.964,4.142,4.142,0,0,1,.008-.81.676.676,0,0,0-.042-.444.493.493,0,0,0-.42-.192.8.8,0,0,0-.488.126,1.017,1.017,0,0,0-.371.775l-1.384,7.578,7.071,10.23Z",
    transform: "translate(-216.842 -136.181)",
    fill: "url(#linear-gradient-15)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M253.139,154.145a.8.8,0,0,1,.488-.126.492.492,0,0,1,.42.192.677.677,0,0,1,.042.444,4.132,4.132,0,0,0-.008.81,2.173,2.173,0,0,0,.318.964l2.407-1.664q-.1-.386-.147-.6t-.107-.571a2.007,2.007,0,0,1-.025-.6,4.6,4.6,0,0,1,.117-.543,1.436,1.436,0,0,1,.293-.551,2.652,2.652,0,0,1,.529-.472,2.011,2.011,0,0,1,1.741-.376,3.133,3.133,0,0,1,1.516,1.008l.3-.206a.255.255,0,0,1,.225-.026.39.39,0,0,1,.217.161.424.424,0,0,1,.074.26.248.248,0,0,1-.1.211l-.277.192a4.583,4.583,0,0,1,.588,1.3q.175.66-.163.894a.89.89,0,0,1-.471.142.457.457,0,0,1-.429-.193,2.118,2.118,0,0,1-.136-.57,2.653,2.653,0,0,0-.333-.92l-2.08,1.438a8.184,8.184,0,0,1,.177.881,4,4,0,0,1,.011.837,1.868,1.868,0,0,1-.306.883,2.8,2.8,0,0,1-.77.759,2.507,2.507,0,0,1-1.8.507,2.688,2.688,0,0,1-1.6-.9l-.343.237a.243.243,0,0,1-.229.014.428.428,0,0,1-.216-.162.4.4,0,0,1-.075-.259.249.249,0,0,1,.1-.2l.312-.216a3.414,3.414,0,0,1-.638-1.8Q252.725,154.431,253.139,154.145Zm5.133-1.773a.915.915,0,0,0-.437.67,3.09,3.09,0,0,0,.122,1.019l1.866-1.29Q259.011,151.861,258.272,152.372Zm-3.476,4.587a1.162,1.162,0,0,0,1.639.2,1.219,1.219,0,0,0,.543-.725,2.34,2.34,0,0,0-.021-.972Z",
    transform: "translate(-229.445 -136.181)",
    fill: "url(#linear-gradient-16)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    d: "M255.65,31.019a1.325,1.325,0,1,1,.337-1.843A1.325,1.325,0,0,1,255.65,31.019Z",
    transform: "translate(-230.183 -25.8)",
    fill: "url(#linear-gradient-17)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(38.851 25.174)",
    fill: "url(#linear-gradient-18)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(13.944 9.333)",
    fill: "url(#linear-gradient-19)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(29.406 31.703)",
    fill: "url(#linear-gradient-20)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3279",
    "data-name": "Path 3279",
    d: "M225.672,37.221l-8.1-30.48a.927.927,0,0,1,.658-1.133l15.91-4.227a.927.927,0,0,1,1.133.658l8.1,30.48a.927.927,0,0,1-.658,1.133l-15.91,4.227A.927.927,0,0,1,225.672,37.221Z",
    transform: "translate(-197.686 -1.217)",
    fill: "url(#linear-gradient-21)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3280",
    "data-name": "Path 3280",
    d: "M233.392,44.352,225.645,15.2a.874.874,0,0,1,.62-1.069L241.05,10.2a.874.874,0,0,1,1.069.62l7.746,29.155a.874.874,0,0,1-.62,1.069L234.46,44.972A.874.874,0,0,1,233.392,44.352Z",
    transform: "translate(-204.968 -9.174)",
    fill: "url(#linear-gradient-22)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3281",
    "data-name": "Path 3281",
    d: "M268.148,64.69a2.8,2.8,0,0,1,1.988-3.426q.092-.024.184-.042a.518.518,0,0,0,.4-.642l-5.436-20.458a.518.518,0,0,0-.668-.357q-.089.03-.181.055a2.8,2.8,0,0,1-3.426-1.988v-.005a.522.522,0,0,0-.637-.378l-5.872,1.56a.522.522,0,0,0-.365.644v.005a2.8,2.8,0,0,1-1.988,3.426q-.092.024-.184.042a.518.518,0,0,0-.4.642L257,64.226a.518.518,0,0,0,.668.357q.089-.03.181-.055a2.8,2.8,0,0,1,3.426,1.988v.005a.522.522,0,0,0,.637.378l5.872-1.56a.522.522,0,0,0,.365-.644Z",
    transform: "translate(-228.355 -33.761)",
    fill: "url(#linear-gradient-23)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 6.38,
    cy: 6.38,
    r: 6.38,
    transform: "translate(26.408 12.033)",
    fill: "url(#linear-gradient-24)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3282",
    "data-name": "Path 3282",
    d: "M279.651,160.423a1.077,1.077,0,0,0,.221-.643,4.366,4.366,0,0,0-.033-.988.48.48,0,0,0,.015-.062l.393-.626a.425.425,0,0,0,.019-.27.391.391,0,0,0-.15-.225.255.255,0,0,0-.22-.051l-.35.093a3.132,3.132,0,0,0-1.085-1.461,2.011,2.011,0,0,0-1.765-.235,2.652,2.652,0,0,0-.658.265,1.436,1.436,0,0,0-.462.42,4.618,4.618,0,0,0-.294.472l0,0-1.114,1.921-.033.053-2.017.536a2.173,2.173,0,0,1,.027-1.015,4.133,4.133,0,0,1,.281-.76.676.676,0,0,0,.111-.432.493.493,0,0,0-.331-.323.8.8,0,0,0-.5-.046,1.017,1.017,0,0,0-.611.6l-3.866,6.663,3.193,12.019Z",
    transform: "translate(-242.497 -140.579)",
    fill: "url(#linear-gradient-25)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M300.654,157.051a.8.8,0,0,1,.5.046.493.493,0,0,1,.331.323.677.677,0,0,1-.111.432,4.145,4.145,0,0,0-.281.76,2.171,2.171,0,0,0-.027,1.015l2.828-.752q.036-.4.063-.611t.092-.573a2.007,2.007,0,0,1,.182-.578,4.618,4.618,0,0,1,.293-.472,1.436,1.436,0,0,1,.462-.42,2.65,2.65,0,0,1,.658-.265,2.011,2.011,0,0,1,1.765.235,3.132,3.132,0,0,1,1.085,1.461l.35-.093a.255.255,0,0,1,.22.051.39.39,0,0,1,.15.225.424.424,0,0,1-.019.27.248.248,0,0,1-.162.166l-.326.086a4.577,4.577,0,0,1,.113,1.423q-.058.68-.456.786a.891.891,0,0,1-.491-.026.457.457,0,0,1-.339-.327,2.117,2.117,0,0,1,.065-.583,2.654,2.654,0,0,0,0-.979l-2.444.649a8.154,8.154,0,0,1-.131.889,4,4,0,0,1-.273.792,1.869,1.869,0,0,1-.586.727,2.8,2.8,0,0,1-.981.453,2.508,2.508,0,0,1-1.869-.133,2.688,2.688,0,0,1-1.2-1.388l-.4.107a.243.243,0,0,1-.22-.064.429.429,0,0,1-.149-.225.4.4,0,0,1,.017-.269.249.249,0,0,1,.162-.153l.367-.1a3.415,3.415,0,0,1,.008-1.907q.274-.855.76-.984Zm5.43.068a.915.915,0,0,0-.638.483,3.09,3.09,0,0,0-.23,1l2.193-.583Q306.953,156.888,306.085,157.119Zm-4.822,3.141a1.162,1.162,0,0,0,1.474.745,1.219,1.219,0,0,0,.757-.5,2.339,2.339,0,0,0,.309-.921Z",
    transform: "translate(-271.45 -140.579)",
    fill: "url(#linear-gradient-26)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    d: "M358.57,27.826a1.325,1.325,0,1,1,.94-1.62A1.325,1.325,0,0,1,358.57,27.826Z",
    transform: "translate(-323.385 -22.748)",
    fill: "url(#linear-gradient-27)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    d: "M429.793,295.9a1.325,1.325,0,1,1,.94-1.62A1.325,1.325,0,0,1,429.793,295.9Z",
    transform: "translate(-387.625 -264.539)",
    fill: "url(#linear-gradient-28)"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(22.423 5.421)",
    fill: "url(#linear-gradient-29)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1.325,
    cy: 1.325,
    r: 1.325,
    transform: "translate(29.406 31.703)",
    fill: "url(#linear-gradient-30)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    d: "M93.565,191.843H56.211a2.619,2.619,0,0,1-2.619-2.619V162.873a2.619,2.619,0,0,1,2.619-2.619H93.565a2.619,2.619,0,0,1,2.619,2.619v26.352A2.619,2.619,0,0,1,93.565,191.843Z",
    transform: "translate(-49.809 -144.543)",
    fill: "url(#linear-gradient-31)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    d: "M76.958,181a2.619,2.619,0,0,0-2.619,2.619v26.352a2.631,2.631,0,0,0,.054.531,2.632,2.632,0,0,0,.531.054h37.354a2.619,2.619,0,0,0,2.619-2.619V181.586a2.632,2.632,0,0,0-.054-.531,2.631,2.631,0,0,0-.531-.054Z",
    transform: "translate(-68.522 -163.256)",
    fill: "url(#linear-gradient-32)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    "data-name": "Path 3288",
    d: "M93.565,160.254h-.007V186.6a2.619,2.619,0,0,1-2.619,2.619H53.592v.007a2.619,2.619,0,0,0,2.619,2.619H93.565a2.619,2.619,0,0,0,2.619-2.619V162.873A2.619,2.619,0,0,0,93.565,160.254Z",
    transform: "translate(-49.809 -144.543)",
    fill: "url(#linear-gradient-33)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    "data-name": "Path 3289",
    d: "M405.136,371.845v-9.011h-9.011Z",
    transform: "translate(-358.76 -327.262)",
    fill: "url(#linear-gradient-34)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    d: "M396.479,287.261H388.63a1.357,1.357,0,0,1-1.356-1.356v-5.6a1.357,1.357,0,0,1,1.356-1.357h7.848a1.357,1.357,0,0,1,1.356,1.357v5.6A1.357,1.357,0,0,1,396.479,287.261Z",
    transform: "translate(-350.777 -251.597)",
    fill: "url(#linear-gradient-35)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M397.03,288.392a1.356,1.356,0,0,0-1.356,1.357v5.6a.36.36,0,0,0,.533.43h7.848a1.356,1.356,0,0,0,1.356-1.356v-5.6a.36.36,0,0,0-.533-.43H397.03Z",
    transform: "translate(-358.353 -260.118)",
    fill: "url(#linear-gradient-36)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M405.818,297.809v-.02l-4.734-4.734a2.864,2.864,0,1,0-4.047,4.047l2.063,2.063h5.362A1.356,1.356,0,0,0,405.818,297.809Z",
    transform: "translate(-358.759 -263.502)",
    fill: "url(#linear-gradient-37)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 2.864,
    cy: 2.864,
    r: 2.864,
    transform: "translate(37.365 28.642)",
    fill: "url(#radial-gradient)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 2.557,
    cy: 2.557,
    r: 2.557,
    transform: "translate(37.673 28.949)",
    fill: "url(#linear-gradient-38)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M403.05,295.225a2.865,2.865,0,0,1-3.844,3.844,2.865,2.865,0,1,0,3.844-3.844Z",
    transform: "translate(-361.539 -266.281)",
    fill: "url(#linear-gradient-39)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M409.46,296.612c0,.735-.867,1.331-1.937,1.331s-1.937-.6-1.937-1.331.867-1.331,1.937-1.331S409.46,295.877,409.46,296.612Z",
    transform: "translate(-367.293 -266.332)",
    fill: "url(#linear-gradient-40)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    d: "M56.211,358.725H81.68L68.568,345.613a.609.609,0,0,0-.545-.338H53.592v10.831A2.619,2.619,0,0,0,56.211,358.725Z",
    transform: "translate(-49.809 -311.425)",
    fill: "url(#linear-gradient-41)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    d: "M33.216,472.856H15.611a.609.609,0,0,1-.609-.609v-2.819a.609.609,0,0,1,.609-.609H33.216a.609.609,0,0,1,.609.609v2.819A.609.609,0,0,1,33.216,472.856Z",
    transform: "translate(-15.002 -422.856)",
    fill: "url(#linear-gradient-42)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M52.28,472.855H39.144a.529.529,0,0,1-.529-.529v-2.979a.529.529,0,0,1,.529-.529H52.28a.529.529,0,0,1,.529.529v2.979A.529.529,0,0,1,52.28,472.855Z",
    transform: "translate(-36.3 -422.855)",
    fill: "url(#linear-gradient-43)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    "data-name": "Path 3298",
    d: "M89.523,472.856H85a.319.319,0,0,1-.319-.319v-3.4a.319.319,0,0,1,.319-.319h4.523a.319.319,0,0,1,.319.319v3.4A.319.319,0,0,1,89.523,472.856Z",
    transform: "translate(-77.85 -422.856)",
    fill: "url(#linear-gradient-43)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M21.031,473.829a.609.609,0,0,0-.609.609v2.819a.609.609,0,0,0,.011.114.621.621,0,0,0,.067,0H38.105a.609.609,0,0,0,.609-.609v-2.819a.61.61,0,0,0-.011-.114.591.591,0,0,0-.067,0Z",
    transform: "translate(-19.891 -427.375)",
    fill: "url(#linear-gradient-45)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M33.216,431.675H15.611a.609.609,0,0,1-.609-.609v-2.819a.609.609,0,0,1,.609-.609H33.216a.609.609,0,0,1,.609.609v2.819A.609.609,0,0,1,33.216,431.675Z",
    transform: "translate(-15.002 -385.713)",
    fill: "url(#linear-gradient-46)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M52.28,431.675H39.144a.529.529,0,0,1-.529-.529v-2.979a.529.529,0,0,1,.529-.529H52.28a.529.529,0,0,1,.529.529v2.979A.529.529,0,0,1,52.28,431.675Z",
    transform: "translate(-36.3 -385.712)",
    fill: "url(#linear-gradient-43)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M89.523,431.675H85a.319.319,0,0,1-.319-.319v-3.4a.319.319,0,0,1,.319-.319h4.523a.319.319,0,0,1,.319.319v3.4A.319.319,0,0,1,89.523,431.675Z",
    transform: "translate(-77.85 -385.713)",
    fill: "url(#linear-gradient-43)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M21.031,432.648a.609.609,0,0,0-.609.609v2.819a.608.608,0,0,0,.011.114.6.6,0,0,0,.067,0H38.105a.609.609,0,0,0,.609-.609v-2.819a.608.608,0,0,0-.011-.114.605.605,0,0,0-.067,0Z",
    transform: "translate(-19.891 -390.232)",
    fill: "url(#linear-gradient-49)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M33.216,390.493H15.611a.609.609,0,0,1-.609-.609v-2.819a.609.609,0,0,1,.609-.609H33.216a.609.609,0,0,1,.609.609v2.819A.609.609,0,0,1,33.216,390.493Z",
    transform: "translate(-15.002 -348.568)",
    fill: "url(#linear-gradient-42)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M52.28,390.492H39.144a.529.529,0,0,1-.529-.529v-2.979a.529.529,0,0,1,.529-.529H52.28a.529.529,0,0,1,.529.529v2.979A.529.529,0,0,1,52.28,390.492Z",
    transform: "translate(-36.3 -348.567)",
    fill: "url(#linear-gradient-43)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M89.523,390.493H85a.319.319,0,0,1-.319-.319v-3.4a.319.319,0,0,1,.319-.319h4.523a.319.319,0,0,1,.319.319v3.4A.319.319,0,0,1,89.523,390.493Z",
    transform: "translate(-77.85 -348.568)",
    fill: "url(#linear-gradient-43)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M21.031,391.466a.609.609,0,0,0-.609.609v2.819a.608.608,0,0,0,.011.114.591.591,0,0,0,.067,0H38.105a.609.609,0,0,0,.609-.609v-2.819a.609.609,0,0,0-.011-.114.613.613,0,0,0-.067,0Z",
    transform: "translate(-19.891 -353.087)",
    fill: "url(#linear-gradient-45)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M33.216,349.312H15.611A.609.609,0,0,1,15,348.7v-2.819a.609.609,0,0,1,.609-.609H33.216a.609.609,0,0,1,.609.609V348.7A.609.609,0,0,1,33.216,349.312Z",
    transform: "translate(-15.002 -311.425)",
    fill: "url(#linear-gradient-42)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M52.28,349.311H39.144a.529.529,0,0,1-.529-.529V345.8a.529.529,0,0,1,.529-.529H52.28a.529.529,0,0,1,.529.529v2.979A.529.529,0,0,1,52.28,349.311Z",
    transform: "translate(-36.3 -311.424)",
    fill: "url(#linear-gradient-43)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M89.523,349.312H85a.319.319,0,0,1-.319-.319v-3.4a.319.319,0,0,1,.319-.319h4.523a.319.319,0,0,1,.319.319v3.4A.319.319,0,0,1,89.523,349.312Z",
    transform: "translate(-77.85 -311.425)",
    fill: "url(#linear-gradient-43)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M21.031,350.285a.609.609,0,0,0-.609.609v2.819a.609.609,0,0,0,.011.114.621.621,0,0,0,.067,0H38.105a.609.609,0,0,0,.609-.609V350.4a.607.607,0,0,0-.011-.114.591.591,0,0,0-.067,0H21.031Z",
    transform: "translate(-19.891 -315.943)",
    fill: "url(#linear-gradient-57)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1a85c08704df0c2cbbacdf7481405a66.svg";
export { ForwardRef as ReactComponent };